const downloadFromUrl = (url: string, fileName: string): void => {
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.style.display = 'none'
  document.body.append(link)
  link.click()

  requestAnimationFrame(() => {
    link.remove()
  })
}

export const downloadFileFromBlob = (blob: Blob, fileName: string): void => {
  const url = globalThis.URL.createObjectURL(blob)

  downloadFromUrl(url, fileName)

  setTimeout(() => {
    globalThis.URL.revokeObjectURL(url)
  }, 300)
}
